var _defs, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.593,
    height: 24.822,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: -0.247,
    x2: 2.617,
    y2: 2.341,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b57e10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e5c35c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff3a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b57e10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1.235,
    y1: 1.594,
    x2: -0.8,
    y2: -0.186,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b57e10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e5c35c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b57e10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 2.309,
    y1: 0.609,
    x2: -0.863,
    y2: 1.284,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b57e10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e5c35c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff3a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b57e10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.025,
    y1: 1.508,
    x2: 1.356,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b57e10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#e5c35c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff3a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f9df7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b57e10"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "d",
    x: 0,
    y: 11.965,
    width: 32.593,
    height: 12.857,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined Shape",
    d: "M11.2 19.459h-.173c-2.32.166-5.539-1.84-8.273-5.069C-.736 10.272.084 3.9.084 3.9A17.773 17.773 0 0 1 7.1 5.938 17.547 17.547 0 0 1 11.109 0a17.511 17.511 0 0 1 4.02 5.938A17.772 17.772 0 0 1 22.14 3.9s.82 6.368-2.667 10.486c-2.629 3.105-5.706 5.079-8 5.078q-.142.004-.273-.005Z",
    transform: "translate(5.185)",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Combined Shape",
    d: "M4.759 13.512q-.071.006-.143.008C1.832 13.377 0 9.081 0 3.8A10.652 10.652 0 0 1 .748 0 10.8 10.8 0 0 1 3.7 2.382q.572.676 1.066 1.362.494-.684 1.066-1.362A10.8 10.8 0 0 1 8.775 0a10.631 10.631 0 0 1 .748 3.8c0 5.284-1.832 9.58-4.622 9.722l-.142-.01Z",
    transform: "translate(11.535 5.93)",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.653 13.947.657 8.7c-1.4-1.792-.473-5.274 2-8.7 2.474 3.431 3.405 6.913 2 8.7Z",
    transform: "translate(13.641 9.677)",
    fill: "url(#c)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Shape",
    d: "M21.9 2.578C25.543.063 29.691-.6 32.593.542a20.387 20.387 0 0 0-9.443 3.807 20.512 20.512 0 0 0-6.841 7.493v.015C16.2 8.742 18.264 5.092 21.9 2.578Zm-5.614 9.264a20.557 20.557 0 0 0-6.839-7.493A20.38 20.38 0 0 0 0 .542C2.906-.6 7.05.063 10.689 2.578s5.7 6.164 5.6 9.279Z",
    transform: "translate(0 11.96)",
    fill: "url(#e)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.58da5fb4c12f8fbb437ff1405bef1a67.svg";
export { ForwardRef as ReactComponent };